import Skeleton from 'react-loading-skeleton';

import { brandColors } from '@/app/constants';

const TicketsLoader = () => {
  return (
    <div className="flex gap-4">
      <Skeleton height={616} width={320} baseColor={brandColors.lightSilver} />
      <Skeleton height={616} width={320} baseColor={brandColors.lightSilver} />
      <Skeleton height={616} width={320} baseColor={brandColors.lightSilver} />
      <Skeleton height={616} width={320} baseColor={brandColors.lightSilver} />
    </div>
  );
};

export default TicketsLoader;
